import styled from 'styled-components';
import {
  Title as DefaultTitle,
  Typography,
  Button as DefaultButton,
  PhoneMessage as PhoneMessageSVG,
  Text,
} from '~components';

export const Title = styled(DefaultTitle)`
  margin-top: 76px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }
`;

export const CountdownDescription = styled(Typography).attrs({ as: 'p' })`
  margin-top: ${({ theme }) => theme.spacing.km10};
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
`;

export const Countdown = styled(Text)`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  letter-spacing: -0.03em;
`;

export const Button = styled(DefaultButton).attrs({
  variant: 'secondary',
})`
  width: 192px;
  margin-top: ${({ theme }) => theme.spacing.km1};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    margin-left: ${({ theme }) => theme.spacing.km0};
  }
`;

export const PhoneMessage = styled(PhoneMessageSVG)`
  margin-left: ${({ theme }) => theme.spacing.km2};
`;
